import { render, staticRenderFns } from "./report-wenzhen.vue?vue&type=template&id=4a56b8f6&scoped=true&"
import script from "./report-wenzhen.vue?vue&type=script&lang=ts&"
export * from "./report-wenzhen.vue?vue&type=script&lang=ts&"
import style0 from "./report-wenzhen.vue?vue&type=style&index=0&id=4a56b8f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a56b8f6",
  null
  
)

export default component.exports